import React from 'react';
import './ConfirmationMsg.css';

export const ConfirmationMsg = ({ text }) => (
  <div aria-label="confirmationText" className="confirmation">
    {text}
  </div>
);
